import select from "./select/select";

export const selectSample = select;